import { createSlice } from '@reduxjs/toolkit';
import { authenticateUser, logoutUser } from './api';
import { config } from '../../utils/utils';
import { getItem, removeItem, setItem } from '../../utils/localStorage';
export interface UserProfileImage {
    fileName: string;
    fileType: string;
    id: string;
    key: string;
    url: string;
}
interface User {
    id: string;
    // firstName: string;
    // lastName: string;
    name: string;
    countryCode: string;
    contactNumber: string;
    email: string;
    mobileNumber: string;
    isTwoFactorAuthEnabbled: boolean;
    userRole: string;
    userProfileImage: UserProfileImage;
    activeState: boolean;
    countryCallingCode: string;
    language: string;
}
interface InitialState {
    accessToken: string;
    user: User;
    isError: boolean;
    isLoading: boolean;
}


const user = {
    id: '',
    // firstName: '',
    // lastName: '',
    name: '',
    countryCode: '',
    contactNumber: '',
    email: '',
    activeState: false,
    userRole: '',
    mobileNumber: '',
    isTwoFactorAuthEnabbled: false,
    language: "",
    countryCallingCode: '',
    userProfileImage: {
        fileName: '',
        fileType: '',
        id: '',
        key: '',
        url: '',
    }
};

const accessToken = localStorage.getItem(config.AUTH_KEY);
const userInfo: User = getItem('info');

const initialState: InitialState = {
    accessToken: accessToken || '',
    user: userInfo ? userInfo : user,
    isError: false,
    isLoading: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logoutUserFromLoacal: (state) => {
            state.accessToken = '';
            state.isError = false;
            state.isLoading = false;
            state.user = user;
            removeItem('c');
            // removeItem(config.ORGANIZATION_ID);
        },
        setUserRole: (state, action) => {
            state.user.userRole = action.payload.userRole;
        },
        login: (state, action) => {
            state.accessToken = action.payload.accessToken;
            state.user = action.payload.user;
        },
        setUserProfile: (state, action) => {
            state.user = action.payload.user;
            setItem('info', action.payload.user);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(authenticateUser.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(authenticateUser.fulfilled, (state, _) => {
            state.isLoading = false;
        });
        builder.addCase(authenticateUser.rejected, (state, _) => {
            state.isLoading = false;
            state.isError = true;
        });
        builder.addCase(logoutUser.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(logoutUser.fulfilled, (state, _) => {
            state.accessToken = '';
            state.user = user;
            state.isLoading = false;
            removeItem('info');
            removeItem('c');
            // removeItem(config.ORGANIZATION_ID);
        });
        builder.addCase(logoutUser.rejected, (state, _) => {
            state.isLoading = false;
            state.isError = true;
        });
    },
});

export const { logoutUserFromLoacal, login, setUserRole, setUserProfile } = authSlice.actions;
export default authSlice.reducer;
